__webpack_require__.p = "/assets/turbo/b2a6424a/quellede/_next/";